import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateHelper {
  // should be implemented using moment js
  public static today(): Date {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  public static toMidnight(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  public static toUTCDateString(date: Date): string {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()).toDateString();
  }

  public static toUTCMidnightDate(date: Date): Date {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  }

  public static toUTCMidnightTomorrow(date: Date): Date {
    const d = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    return new Date(d.getTime() + 86400000);
  }

  public static pushMultiple(arrayFrom: Array<any>, arrayTo: Array<any>): void {
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < arrayFrom.length; i++) {
      arrayTo.push(arrayFrom[i]);
    }
  }

  public static clear(array: Array<any>): void {
    while (array.length > 0) {
      array.pop();
    }
  }

  public static formatTimestamp(value: string): string {
    return value.substring(0, this.length - 4) + ' UTC';
  }
}
